import { apiEndpoints } from "../services/apiConfig";

let socket = null;

export const connectChatSocket = (token, onMessage) => {
  const wsUrl = apiEndpoints.sendMessage.replaceAll(
    "{token}",
    encodeURIComponent(token || "")
  );

  socket = new WebSocket(wsUrl);

  socket.onopen = () => {console.log("ws connected")};

  socket.onmessage = (event) => {
    if (onMessage) onMessage(event.data); // ✅ just callback
  };

  socket.onclose = (e) => console.log("WS closed", e.code, e.reason);
  socket.onerror = (e) => console.log("WS error", e);

  return socket;
};

export const sendChatOverSocket = (message) => {
  if (!socket || socket.readyState !== WebSocket.OPEN) {
    throw new Error("WebSocket not connected");
  }
  socket.send(message); // or JSON.stringify({message})
};

export const disconnectChatSocket = () => {
  if (socket) socket.close();
  socket = null;
};
